import React, {Component} from "react"
import {Col} from "react-bootstrap"
import styled from "styled-components"

import Form from "@irati/ui/src/Form"
import {Checkbox} from "@irati/ui/src/FormItem"
import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {Row, RowMiddle, RowEnd} from "../../Row"

const SmallForm = styled(Form)`
  height: 25px;
`

const UserFilterRowStart = styled.div`
  width: 120px;
`

interface Props {
  checked: boolean
  onToggleAll: () => void
  hideTeam: boolean
  hideBusinessUnit: boolean
}

class UserFilter extends Component<Props> {
  static defaultProps = {
    checked: false,
    hideTeam: false,
    hideBusinessUnit: false
  }

  render() {
    const {checked, onToggleAll, hideTeam, hideBusinessUnit} = this.props

    return (
      <Row>
        <UserFilterRowStart>
          <SmallForm>
            <Checkbox name="check_allUsers" checked={checked} onChange={onToggleAll} />
          </SmallForm>
        </UserFilterRowStart>
        <RowMiddle>
          <Col xs={2}>
            <Label large weight="bold">
              <FormattedMessage id="admin.components.userFilter.userName" />
            </Label>
          </Col>
          {hideTeam ? (
            <Col xs={2}>
              <Label large weight="bold">
                <FormattedMessage id="admin.components.userFilter.teamAccess" />
              </Label>
            </Col>
          ) : (
            <Col xs={2}>
              <Label large weight="bold">
                <FormattedMessage id="admin.components.userFilter.team" />
              </Label>
            </Col>
          )}
          {!hideBusinessUnit && (
            <Col xs={2}>
              <Label large weight="bold">
                <FormattedMessage id="admin.components.userFilter.countries" />
              </Label>
            </Col>
          )}
          <Col xs={2}>
            <Label large weight="bold">
              <FormattedMessage id="admin.components.userFilter.employmentStartDate" />
            </Label>
          </Col>
          <Col xs={2}>
            <Label large weight="bold">
              <FormattedMessage id="admin.components.userFilter.dateOfBirth" />
            </Label>
          </Col>
        </RowMiddle>
        <RowEnd />
      </Row>
    )
  }
}

export default UserFilter
